module.exports = __webpack_public_path__ + "img/product-bg.440eed18.jpg";